import { Env } from './env';

/**
 * يحول معرف الملف (fileId) إلى رابط تحميل كامل عبر Cloudflare Worker
 */
export const getBackblazeDownloadUrl = (fileId) => {
  if (!fileId) return null;
  if (fileId.startsWith('http')) return fileId;
  return `${Env.cloudflareWorkerUrl}/file/${fileId}?t=${Env.cloudflareSecretToken}`;
};

/**
 * يعرض أي رابط مخزّن — Cloudinary قديم أو Backblaze B2
 */
export const getMediaUrl = (url) => getBackblazeDownloadUrl(url);
